/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets (one column each, header = set name)`)
};

const es_venn_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos (una columna cada uno, encabezado = nombre del conjunto)`)
};

const de_venn_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengen (je eine Spalte, Kopfzeile = Mengenname)`)
};

const nl_venn_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets (elk één kolom, koptekst = setnaam)`)
};

const fr_venn_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensembles (une colonne chacun, en-tête = nom de l'ensemble)`)
};

const it_venn_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insiemi (una colonna ciascuno, intestazione = nome dell'insieme)`)
};

const pt_br2_venn_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos (uma coluna cada, cabeçalho = nome do conjunto)`)
};

const pt_venn_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos (uma coluna cada, cabeçalho = nome do conjunto)`)
};

const ja_venn_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集合(各列1つずつ、ヘッダー = 集合名)`)
};

const zh_venn_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集合（每列一个，表头为集合名称）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_input_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_input_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_input_label", locale)
	if (locale === "en") return en_venn_input_label(inputs)
	if (locale === "es") return es_venn_input_label(inputs)
	if (locale === "de") return de_venn_input_label(inputs)
	if (locale === "nl") return nl_venn_input_label(inputs)
	if (locale === "fr") return fr_venn_input_label(inputs)
	if (locale === "it") return it_venn_input_label(inputs)
	if (locale === "pt-BR") return pt_br2_venn_input_label(inputs)
	if (locale === "pt") return pt_venn_input_label(inputs)
	if (locale === "ja") return ja_venn_input_label(inputs)
	return zh_venn_input_label(inputs)
};